module.exports = __webpack_public_path__ + "static/media/futomak_tuna.a19d6600.jpeg";